import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}/wallet/`;

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    if (!token) {
        console.error('No se encontró un token válido.');
        throw new Error('Usuario no autenticado');
    }
    return { Authorization: `Bearer ${token}` };
};

const handleError = (error) => {
    if (error.response?.data?.message === 'Invalid token') {
        console.error('Token inválido. Eliminando token de localStorage.');
        localStorage.removeItem('token'); // Eliminar el token inválido
        throw new Error('Token inválido. Por favor, inicie sesión nuevamente.');
    } else {
        console.error(error.response?.data || error.message);
        throw error;
    }
};

export const generateAddress = async () => {
    try {
        const headers = getAuthHeaders();
        return await axios.post(`${API_URL}generate-address`, {}, { headers });
    } catch (error) {
        handleError(error);
    }
};

export const getBlockchainInfo = async () => {
    try {
        const headers = getAuthHeaders();
        return await axios.get(`${API_URL}getblockchaininfo`, { headers });
    } catch (error) {
        handleError(error);
    }
};

export const getAddresses = async () => {
    try {
        const headers = getAuthHeaders();
        return await axios.get(`${API_URL}addresses`, { headers });
    } catch (error) {
        handleError(error);
    }
};

export const getBalance = async () => {
    try {
        const headers = getAuthHeaders();
        const response = await axios.get(`${API_URL}balance`, { headers });
        //console.log(response.data);
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

export const getRecentTransactions = async () => {
    try {
        const headers = getAuthHeaders();
        return await axios.get(`${API_URL}recent-transactions`, { headers });
    } catch (error) {
        handleError(error);
    }
};

export const sendTransaction = async (payload) => {
    try {
        const headers = getAuthHeaders();
        const response = await axios.post(`${API_URL}send`, payload, { headers });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

export const getUserUtxos = async () => {
    try {
        const headers = getAuthHeaders();
        return await axios.get(`${API_URL}utxos`, { headers });
    } catch (error) {
        handleError(error);
    }
};

export const checkUTXOs = async () => {
    try {
        const headers = getAuthHeaders();
        const response = await axios.get(`${API_URL}utxos`, { headers });
        //console.log("checkUTXOs: " + response.data);
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

export const lanzarDado = async (payload) => {
    try {
        const headers = getAuthHeaders();
        const response = await axios.post(`${API_URL}lanzar-dado`, payload, { headers });
        return response.data;
    } catch (error) {
        handleError(error);
    }
};

export const getFundsDistribution = async () => {
  try {
    const headers = getAuthHeaders();
    const response = await axios.get(`${API_URL}fundsdistribution`, { headers });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};
